import React from "react";
import ServiceItems from "../components/ServiceItems";
import si1 from "../assets/img/service-icons/01.svg";
import si2 from "../assets/img/service-icons/02.svg";
import si3 from "../assets/img/service-icons/03.svg";
import si4 from "../assets/img/service-icons/04.svg";
import si5 from "../assets/img/service-icons/05.svg";
import si6 from "../assets/img/service-icons/06.svg";
import si7 from "../assets/img/service-icons/07.svg";
import si8 from "../assets/img/service-icons/08.svg";
import si9 from "../assets/img/service-icons/09.svg";
import si10 from "../assets/img/service-icons/10.svg";
import si11 from "../assets/img/service-icons/11.svg";
import si12 from "../assets/img/service-icons/12.svg";
import si13 from "../assets/img/service-icons/13.svg";
import si14 from "../assets/img/service-icons/14.svg";
import si15 from "../assets/img/service-icons/15.svg";
import si16 from "../assets/img/service-icons/16.svg";

export default function AllServices() {
  const services = [
    {
      icon: si1,
      title: "Project Management",
      desc: "End-to-end coordination ensuring timely and efficient execution of your project.",
    },
    {
      icon: si2,
      title: "Design & Execution",
      desc: "Innovative designs seamlessly brought to life with precision execution.",
    },
    {
      icon: si3,
      title: "Material Selection",
      desc: "Expert guidance in choosing the best materials for durability and aesthetics.",
    },
    {
      icon: si4,
      title: "Procurement",
      desc: "Hassle-free sourcing of high-quality materials at competitive prices.",
    },
    {
      icon: si5,
      title: "Vendor Management",
      desc: "Streamlined communication and coordination with reliable vendors.",
    },
    {
      icon: si6,
      title: "Electrical Services",
      desc: "Safe and efficient electrical installations tailored to your needs.",
    },
    {
      icon: si7,
      title: "Plumbing Services",
      desc: "Reliable plumbing solutions ensuring smooth water flow and waste management.",
    },
    {
      icon: si8,
      title: "Civil Modifications",
      desc: "Structural changes executed with safety, compliance, and accuracy.",
    },
    {
      icon: si9,
      title: "False Ceiling",
      desc: "Customized ceiling solutions for improved aesthetics and functionality.",
    },
    {
      icon: si10,
      title: "On-site Carpentry",
      desc: "Skilled carpentry delivering functional and stylish woodwork on-site.",
    },
    {
      icon: si11,
      title: "Tiling Solutions",
      desc: "Precision tiling for a clean, polished, and durable finish.",
    },
    {
      icon: si12,
      title: "Fabrication Services",
      desc: "Custom metal fabrication to suit various structural and design needs.",
    },
    {
      icon: si13,
      title: "Painting Solutions",
      desc: "Professional painting services for a flawless and vibrant finish.",
    },
    {
      icon: si14,
      title: "Modular Fit Outs",
      desc: "Smart modular solutions for efficient and elegant space utilization.",
    },
    {
      icon: si15,
      title: "Quality Control",
      desc: "Strict quality checks at every stage to ensure excellence.",
    },
    {
      icon: si16,
      title: "Final Product Delivery",
      desc: "Timely handover of a fully finished and ready-to-use space.",
    },
  ];
  return (
    <>
      <div
        className="container"
        style={{ background: "#faf7f5", padding: "0px 30px" }}
      >
        <div className="ptb-4">
          <div className="row">
            {services.map((service, index) => (
              <ServiceItems
                key={index}
                icon={service.icon}
                title={service.title}
                desc={service.desc}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
